import { OrgUnitType } from '@retail/mgpris/config-types';
import { priceSuggestionOptions } from '@retail/products/types';
import { BindingLevel, priceSuggestionTypeRules } from './priceSuggestionTypeRules';

interface Props {
  countryCode: string;
  orgUnitType: OrgUnitType;
  canReadLocal: boolean;
  assortmentLevel: boolean;
}

export const getAvailableTypes = ({
  countryCode,
  orgUnitType,
  canReadLocal,
  assortmentLevel,
}: Props) => {
  const bindingLevel: BindingLevel = assortmentLevel ? 'ASSORTMENT' : 'SUPPLIER';

  return priceSuggestionOptions.filter((type) => {
    if (type === 'LOCAL' && !canReadLocal) return false;

    const { bindingLevels, scopes } = priceSuggestionTypeRules[type];
    const inScope = scopes.some(
      (scope) =>
        (scope.orgUnitType === undefined || scope.orgUnitType === orgUnitType.baseType) &&
        (scope.country === undefined || scope.country === countryCode)
    );
    return bindingLevels.includes(bindingLevel) && inScope;
  });
};
